/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, styled, Typography, TypographyProps } from "@mui/material";
import React from "react";

const TitleBoxWrapper = styled(Box)({
  maxWidth: "688px",
});

export interface TitleBoxProps {
  display?: string | React.ReactNode;
  displayProps?: TypographyProps;
  subheading?: string | React.ReactNode;
  subheadingProps?: TypographyProps;
  body?: string | React.ReactNode;
  bodyProps?: TypographyProps;
}
const TitleBox = ({
  display,
  displayProps,
  subheading,
  subheadingProps,
  body,
  bodyProps,
  ...rest
}: TitleBoxProps) => {
  return (
    <TitleBoxWrapper {...rest}>
      {display && typeof display === "string" && (
        <Typography
          variant="h1"
          gutterBottom={!subheading || typeof subheading === "object"}
          mb={0}
          {...displayProps}
        >
          {display}
        </Typography>
      )}
      {typeof display === "object" && display}
      {subheading && typeof subheading === "string" && (
        <Typography variant="h2" gutterBottom {...subheadingProps}>
          {subheading}
        </Typography>
      )}
      {typeof subheading === "object" && subheading}

      {body && typeof body === "string" && (
        <Typography
          variant="body1"
          sx={{
            ...bodyProps?.sx,
            mt: display && !subheading ? 2 : 0,
          }}
        >
          {body}
        </Typography>
      )}

      {typeof body === "object" && body}
    </TitleBoxWrapper>
  );
};

export default TitleBox;
